'use strict';
const	React									= require('react')
		, LoginIndexComponentResolver			= require('modules/resolvers/login/popup/index.resolver')
		, LoginVerifyComponentResolver			= require('modules/resolvers/login/popup/verify.resolver')
		, LoginForgotComponentResolver			= require('modules/resolvers/login/popup/forgot.resolver')
		, LoginSignupBasicComponentResolver		= require('modules/resolvers/login/popup/signup.basic.resolver')
		, LoginSignupGoogleComponentResolver	= require('modules/resolvers/login/popup/signup.google.resolver')
		, LoginSignupFacebookComponentResolver	= require('modules/resolvers/login/popup/signup.facebook.resolver')
		, LoginForgotSuccessComponentResolver	= require('modules/resolvers/login/popup/forgot.success.resolver')
		, ComponentResolver						= require('peons/ComponentResolver')
		, DefaultLoading						= <div className="col col-8 is-loading"></div>
		;

module.exports = {
	construct : function(){
		this.state = {
			partial : 'index',
			component : DefaultLoading
		}

		this.updateView();
	},
	componentDidMount : function(){
		this.manager.dispatch({
			type : 'PAGECOUNT_SET',
			payload : 10
		})
	},
	childContextTypes : {
		parent : React.PropTypes.objectOf(React.PropTypes.func)
	},
	getChildContext : function(){
		return {
			parent : {
				onIndex:()=>{
					//this.location.replace('login');
					this.setState({
						partial : 'index'
					},()=>{
						this.updateView();
					})

				},
				onForgot:()=>{
					//this.location.replace('login/forgot')
					if(window.location.href.match('/forgotpassword')) {
						this.context.popup &&
						this.context.popup.dismissLast();

						this.manager.dispatch({
							type : 'FORGOT_PASSWORD_RESETTED',
							payload : false
						});
					} else {
						window.location.href = '/forgotpassword'
					}
					// this.setState({
					// 	partial : 'forgot'
					// },()=>{
					// 	this.updateView();
					// })
				},
				onResetSuccess:()=>{
					//this.location.replace('login/forgot/success')
					this.setState({
						partial : 'forgot.success'
					},()=>{
						this.updateView();
					})
				},
				onSignUpBasic:()=>{
					//this.location.replace('login/signup/basic')
					this.setState({
						partial : 'signup.basic'
					},()=>{
						// this.updateView();
					})
				},
				onSignUpGoogle:()=>{
					//this.location.replace('login/signup/google')
					this.setState({
						partial : 'signup.google'
					},()=>{
						this.updateView();
					})
				},
				onSignUpFacebook:()=>{
					//this.location.replace('login/signup/facebook')
					this.setState({
						partial : 'signup.facebook'
					},()=>{
						this.updateView();
					})
				},
				onVerify:()=>{
					//this.location.replace('login/verify')
					this.setState({
						partial : 'verify'
					},()=>{
						// this.updateView();
					})
				},
				onLoginSuccess:()=>{
					this.context.popup &&
					this.context.popup.dismissLast();
				}
			}
		}
	},
	methods : {
		updateView : function() {

			if(this.hasMounted)
				this.setState({
					component : DefaultLoading
				});

			switch(this.state.partial) {
			case 'index' :
				ComponentResolver.resolve(LoginIndexComponentResolver,{manager:this.manager})
					.then(this._handle_module());
				break;
			case 'forgot' :
				ComponentResolver.resolve(LoginForgotComponentResolver,{manager:this.manager})
					.then(this._handle_module());
				break;
			case 'forgot.success' :
				ComponentResolver.resolve(LoginForgotSuccessComponentResolver,{manager:this.manager})
					.then(this._handle_module());
				break;
			case 'signup.facebook' :
				ComponentResolver.resolve(LoginSignupFacebookComponentResolver,{manager:this.manager})
					.then(this._handle_module());
				break;
			case 'signup.google' :
				ComponentResolver.resolve(LoginSignupGoogleComponentResolver,{manager:this.manager})
					.then(this._handle_module());
				break;
			}
		},
		_handle_module : function() {
			return (Module)=>{
				this.hasMounted && this.setState({
					component : <Module title={this.props.title} />
				})
			}
		},
		closePopup : function(e) {
			e.preventDefault();

			this.context.popup &&
			this.context.popup.dismissLast()
		},
		showIndex: function(e) {
			e.preventDefault();

			this.setState({
				partial : 'index'
			},()=>{
				this.updateView();
			})
		}
	},
	stateToProps : (state)=>{
		return {
			email : state.registration && state.registration.email
		}
	}
}



// WEBPACK FOOTER //
// resources/modules/components/popup/login/config.jsx